import { FieldNode, Kind, SelectionNode } from 'graphql';

export const addFieldSelection = (field: FieldNode, subField: SelectionNode): void => {
  (field.selectionSet as any) = {
    ...field.selectionSet,
    kind: Kind.SELECTION_SET,
    selections: [...(field.selectionSet?.selections ?? []), subField],
  };
};
